import { useState } from "react";

import { EditIcon } from "@dotnet/telematics-design-system";

import { UsersDataDto } from "../../../../../Pages/Users/types/types";
import { USER_ROLES_RAW_DATA } from "../../../../../roles/types/enums";
import { RenderConditionOptions, USERS_ACTIONS } from "../../../../../shared";
import {
  getEnvironment,
  replaceCamelCaseStringToSeparateWords
} from "../../../../../shared/functions/functions";

const useUsersInlineActions = (isAllowedFullControlOfUsers: boolean) => {
  const { isProductionEnv } = getEnvironment();

  const [rowData, setRowData] = useState<UsersDataDto | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const openDialog = (data: UsersDataDto) => {
    setRowData(data);
    setIsOpen(true);
  };

  const closeDialog = () => {
    setRowData(null);
    setIsOpen(false);
  };

  const handleEditUser = (data: UsersDataDto) => {
    openDialog(data);
  };

  const isUserHimself = (id: number, loggedUserId: number) =>
    id === loggedUserId;

  const inlineRenderConditions = ({ data, user }: RenderConditionOptions) => {
    const supportRole = replaceCamelCaseStringToSeparateWords(
      USER_ROLES_RAW_DATA.TeltonikaSupport
    );

    const isNotSelf = !isUserHimself(data?.id, user?.id);

    if (isProductionEnv) {
      const isNotSupportUser = data?.role !== supportRole;

      return isAllowedFullControlOfUsers
        ? isNotSelf
        : isNotSelf && isNotSupportUser;
    }

    return isNotSelf;
  };

  const inlineActions = [
    {
      title: USERS_ACTIONS.EditUser,
      icon: <EditIcon />,
      clickAction: handleEditUser,
      renderConditions: ({ data, user }: RenderConditionOptions) =>
        inlineRenderConditions({ data, user })
    }
  ];

  return {
    inlineActions,
    rowData,
    isOpen,
    openDialog,
    closeDialog
  };
};

export default useUsersInlineActions;
